import type { ReactNode } from "react";
import styles from "./drawer-footer.module.css";

/**
 * A drawer form's buttons, pinned to the bottom of the drawer while its fields scroll. `start`
 * sits apart on the left (a Remove); the rest end on the right, the main action last.
 */
export function DrawerFooter({ start, children }: { start?: ReactNode; children: ReactNode }) {
  return (
    <div className={styles.footer}>
      {start ? <span className={styles.start}>{start}</span> : null}
      {children}
    </div>
  );
}
